import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/Common";
import { StatusBadge } from "@/components/StatusBadge";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function ActionQueue() {
  const [orders, setOrders] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.orders().then(setOrders).catch(() => {}); }, []);
  const queue = orders.filter((o) => ["ACTION_NEEDED", "CLARIFICATION_REQUESTED", "RESUBMITTED"].includes(o.latest_status || o.status));

  return (
    <div>
      <PageHeader testid="action-queue-header" title="Action Queue"
        subtitle="Orders with outstanding operational actions before testing can proceed with stronger supporting evidence." />
      {queue.length === 0 ? (
        <Card className="p-8 text-center text-sm text-slate-500">No outstanding actions. All evaluated orders are READY or in review.</Card>
      ) : (
        <div className="space-y-3">
          {queue.map((o) => (
            <Card key={o.id} className="flex flex-wrap items-center justify-between gap-3 p-4" data-testid={`aq-${o.id}`}>
              <div>
                <div className="flex items-center gap-2">
                  <span className="font-display font-semibold text-slate-900">{o.patient_name}</span>
                  <StatusBadge status={o.latest_status || o.status} size="sm" />
                </div>
                <div className="mt-1 text-xs text-slate-500">{o.order_number} · {o.test_name} · {o.payer_name}</div>
                <div className="mt-1 text-xs text-amber-800">{o.latest_summary}</div>
              </div>
              <Button size="sm" variant="outline" data-testid={`aq-open-${o.id}`} onClick={() => nav(`/orders/${o.id}`)}>Open & Resolve</Button>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
